<template>
  <div class="page-container">
    <!-- 筛选查询区 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="search" size="small">
        <el-form-item label="类型">
          <el-select v-model="search.type" placeholder="全部" clearable style="width:120px;">
            <el-option label="入金" :value="1"></el-option>
            <el-option label="出金" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种">
          <el-select v-model="search.currency" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search.isDelete" placeholder="全部" clearable style="width:120px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">出入金模版配置</span>
        <div class="table-actions">
          <button class="btn btn-primary btn-sm" @click="openAddModal">+ 新增金额模版</button>
        </div>
      </div>
      <el-table ref="table" :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column label="排序" width="80" align="center">
          <template slot-scope="{row}">
            <el-input-number v-model="row.sort" :min="0" :controls="false" size="mini" style="width:56px;" @change="updateSort(row)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="templateName" label="模版名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="类型" width="90">
          <template slot-scope="{row}">
            <el-tag :type="row.type === 1 ? 'success' : 'warning'" size="mini">{{ row.typeName || (row.type === 1 ? '入金' : '出金') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="currency" label="币种" width="90">
          <template slot-scope="{row}">{{ row.currency || '--' }}</template>
        </el-table-column>
        <el-table-column label="金额档位" min-width="220">
          <template slot-scope="{row}">
            <span v-for="(a, i) in (row.amounts || [])" :key="i" class="amount-badge">{{ fmtMoney(a) }}</span>
            <span v-if="!row.amounts || !row.amounts.length" style="color:#909399;">--</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="100">
          <template slot-scope="{row}">{{ row.createUser || '--' }}</template>
        </el-table-column>
        <el-table-column prop="updateUser" label="最后更新人" width="110">
          <template slot-scope="{row}">{{ row.updateUser || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
        </el-table-column>
        <el-table-column label="最后更新时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.updateDate) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleStatus(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="openEditModal(row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#dc2626;" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="editVisible" width="560px" :close-on-click-modal="false" :title="editForm.id ? '编辑金额模版' : '新增金额模版'">
      <el-form :model="editForm" label-width="90px" size="small" :rules="editRules" ref="editForm">
        <el-form-item label="模版名称" prop="templateName">
          <el-input v-model="editForm.templateName" maxlength="16" placeholder="最多16个字符"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio :label="1">入金</el-radio>
            <el-radio :label="2">出金</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="币种" prop="currency">
          <el-select v-model="editForm.currency" style="width:100%;" placeholder="请选择币种">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额档位" prop="amounts">
          <el-input v-model="editForm.amounts" placeholder="请输入金额档位，用英文逗号分隔"></el-input>
          <div style="font-size:12px;color:#909399;margin-top:4px;">如 100,500,1000</div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.sort" :min="0" style="width:180px;"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.isDelete" style="width:180px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" @click="submitSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paymentTemplatesConfigList, paymentTemplatesConfigAddOrUpdate, paymentTemplatesConfigDelete, paymentTemplatesConfigStatus, paymentTemplatesConfigUpdateSort } from '@/api/paymentTemplatesConfig'

export default {
  name: 'PaymentTemplatesConfigList',
  data() {
    return {
      tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15,
      currencies: ['ZAR', 'CNY', 'USD', 'USDT'],
      search: { type: null, currency: '', isDelete: null },
      editVisible: false,
      editForm: { id: null, templateName: '', type: 1, currency: '', amounts: '', sort: 0, isDelete: 1 },
      editRules: {
        templateName: [{ required: true, message: '请输入模版名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        currency: [{ required: true, message: '请选择币种', trigger: 'change' }],
        amounts: [{ required: true, message: '请输入金额档位', trigger: 'blur' }]
      }
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize }
      Object.keys(this.search).forEach(k => {
        if (this.search[k] !== '' && this.search[k] !== null) params[k] = this.search[k]
      })
      paymentTemplatesConfigList(params).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    searchList() { this.pageNum = 1; this.fetchList() },
    resetSearch() {
      this.search = { type: null, currency: '', isDelete: null }
      this.pageNum = 1; this.fetchList()
    },
    fmtMoney(v) { return v === null || v === undefined || v === '' ? '0.00' : Number(v).toFixed(2) },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' },
    openAddModal() {
      this.editForm = { id: null, templateName: '', type: 1, currency: '', amounts: '', sort: 0, isDelete: 1 }
      this.editVisible = true
    },
    openEditModal(row) {
      this.editForm = {
        id: row.id,
        templateName: row.templateName,
        type: row.type,
        currency: row.currency,
        amounts: (row.amounts || []).join(','),
        sort: row.sort || 0,
        isDelete: row.isDelete
      }
      this.editVisible = true
    },
    submitSave() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const amounts = this.editForm.amounts.split(',').map(s => Number(s.trim())).filter(n => !isNaN(n) && n > 0)
        if (!amounts.length) { this.$message.warning('请输入有效的金额档位'); return }
        paymentTemplatesConfigAddOrUpdate(this.editForm).then(res => {
          if (res.code === 0) {
            this.$message.success(this.editForm.id ? '保存成功' : '新增成功')
            this.editVisible = false; this.fetchList()
          } else this.$message.error(res.message || '操作失败')
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除金额模版「' + row.templateName + '」？删除后不可恢复。', '删除确认', { type: 'warning' }).then(() => {
        paymentTemplatesConfigDelete(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchList() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    toggleStatus(row) {
      const disabling = row.isDelete === 2
      const apply = () => {
        paymentTemplatesConfigStatus(row.id, disabling ? 2 : 1).then(res => {
          if (res.code === 0) {
            this.$message.success(disabling ? '已禁用：' + row.templateName : '已启用：' + row.templateName)
            this.fetchList()
          } else this.$message.error(res.message || '操作失败')
        })
      }
      if (disabling) {
        this.$confirm('禁用后该模版将不可用于新的出入金请求，是否确认？', '禁用确认', { type: 'warning' }).then(apply).catch(() => { this.fetchList() })
      } else {
        apply()
      }
    },
    updateSort(row) {
      if (!row.id) return
      paymentTemplatesConfigUpdateSort(row.id, row.sort).then(res => {
        if (res.code === 0) this.fetchList()
        else this.$message.error(res.message || '保存排序失败')
      })
    }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.filter-bar { background: #fff; border-radius: 10px; padding: 14px 16px 4px; margin-bottom: 14px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-primary { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-sm { padding: 5px 10px; font-size: 12px; }
.amount-badge { display: inline-block; background: var(--brand-primary-a12); color: var(--brand-primary); border-radius: 4px; padding: 1px 7px; margin: 2px 4px 2px 0; font-size: 12px; }
</style>
